import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { CorsConfig, CorsListResponse } from '../app/models/cors.model';

@Injectable({ providedIn: 'root' })
export class CorsService {

  constructor(private http: HttpClient) {}

  getCorsConfigs() {
    return this.http.get<CorsConfig[]>(
      `${environment.baseUrl}/admin/internal/cors`
    );
  }

  createCors(payload: any) {
    return this.http.post<CorsConfig>(`${environment.baseUrl}/admin/internal/cors`, payload);
  }

  updateCors(id: number, payload: any) {
    return this.http.put<CorsConfig>(`${environment.baseUrl}/admin/internal/cors/${id}`, payload);
  }

  deleteCors(id: number) {
    return this.http.delete(`${environment.baseUrl}/admin/internal/cors/${id}`);
  }

}

